import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import { Spin } from "antd";
import Swal from "sweetalert2";
import { ADD_ACTIVITY, getApiBaseUrl } from "../Config/Config";
import dayjs from "dayjs";

const BackUpRestore = () => {
  const [backupLogs, setBackupLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [backupLoading, setBackupLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [password, setPassword] = useState("");

  const fetchBackupLogs = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}/backup/logs`);
      const data = await response.json();
      setBackupLogs(data || []);
    } catch (error) {
      console.error("Error fetching backup logs:", error);
    }
    setLoading(false);
  };
  console.log(backupLogs, "baaaaaaaaaa");
  useEffect(() => {
    fetchBackupLogs();
  }, []);

  const columns = [
    {
      title: "Database Name",
      dataIndex: "DatabaseName",
      key: "DatabaseName",
      render: (text) => text || "N/A",
    },
    {
      title: "Backup File Name",
      dataIndex: "BackupFileName",
      key: "BackupFileName",
      render: (text) => text || "N/A",
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      render: (text) => text || "N/A",
    },
    {
      title: "Error Message",
      dataIndex: "ErrorMessage",
      key: "ErrorMessage",
      render: (text) => text || "N/A",
    },
    {
      title: "Backup Time",
      dataIndex: "BackupTime",
      key: "BackupTime",
      render: (text) =>
        text ? dayjs(text).format("DD/MM/YYYY HH:mm:ss") : "N/A",
    },
    {
      title: "User ID",
      dataIndex: "UserName",
      key: "UserName",
      render: (text) => text || "N/A",
    },
  ];

  //   {
  //     title: "Actions",
  //     dataIndex: "status",
  //     key: "status",
  //     render: () => (
  //       <div className="action-table-data">
  //         <div className="edit-delete-action d-flex align-items-center">
  //           <Link
  //             to="#"
  //             className=" me-2 p-2"
  //             //   data-bs-toggle="offcanvas"
  //             //   data-bs-target="#AssetitemBarcode"
  //             title="Restore"
  //           >
  //             <i className="fa-solid fa-arrows-rotate  text-dark"></i>
  //           </Link>
  //         </div>
  //       </div>
  //     ),
  //   },
  // ];

  const [userData, setUserData] = useState();
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    setUserData(user);
  }, []);

  const handleBackupProcess = async (userPassword) => {
    setBackupLoading(true);

    const loginPayload = {
      username: userData?.UserName,
      password: userPassword,
    };

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginPayload),
      });

      const loginData = await loginRes.json();

      if (!loginData.status) {
        throw new Error(loginData.Message);
      }

      const performedBy = loginData?.ResultData?.UserID || 0;

      // 2. Call Backup API
      let backupSuccess = false;
      let backupMessage = "";

      try {
        const backupRes = await fetch(
          `${getApiBaseUrl()}/backup/backup?UserID=${userData?.UserID}`
        );
        const backupData = await backupRes.json();

        if (backupData.status === "success") {
          backupSuccess = true;
          backupMessage = backupData.message;
        } else {
          backupMessage = "Backup failed. Please try again.";
        }
      } catch (backupErr) {
        backupMessage = "Error occurred while calling backup API.";
      }

      // 3. Audit Log
      const auditPayload = {
        ActivityType: 1,
        PerformedBy: performedBy,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: backupSuccess
          ? "Backup completed successfully"
          : "Backup failed",
        Location: "login",
        IsSucces: backupSuccess ? 1 : 0,
      };

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditPayload),
      });

      // 4. Show Swal result
      Swal.fire({
        icon: backupSuccess ? "success" : "error",
        title: backupSuccess ? "Backup success" : "Backup failed",
        text: backupMessage,
        confirmButtonText: "OK",
      }).then(() => {
        fetchBackupLogs();
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong.",
      });
    }

    setBackupLoading(false);
  };

  const handleSubmitPassword = () => {
    setShowModal(false);
    handleBackupProcess(password);
  };
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Backup Management
                  </h4>
                </ol>
              </nav>
              <h6>Backup and Restore your data</h6>
            </div>
          </div>
          {/* <div className="page-btn">
            <button
              className="btn btn-sm btn-primary"
              title="Save Changes"
              type="submit"
            >
              <i className="fa fa-check fs-4 "></i>
            </button>
          </div> */}
        </div>
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <i className="fa-solid fa-database fa-lg me-2"></i>Backup
          </div>
          <div className="card-body d-flex">
            {/* <div className="me-2">
              <label>Automatic backup every</label>
              <div className="input-group">
                <input
                  type="number"
                  name="expiryDays"
                  className="form-control"
                  onWheel={(e) => e.target.blur()}
                />
                <span className="input-group-text">Days</span>
              </div>
            </div> */}
            <div>
              Take backup{" "}
              <button
                className="btn btn-primary "
                onClick={() => setShowModal(true)}
                disabled={backupLoading}
              >
                {backupLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Backing up...
                  </>
                ) : (
                  "Now"
                )}
              </button>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center mb-2">
          <i className="fa-solid fa-book me-2 fa-lg"></i>
          <h4>Backup History</h4>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set m-3"></div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : backupLogs?.length > 0 ? (
                <Table columns={columns} dataSource={backupLogs} rowKey="id" />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Password</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => setShowModal(false)}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="pass-group">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    name="password"
                    className="pass-input form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    onCopy={(e) => e.preventDefault()}
                    onPaste={(e) => e.preventDefault()}
                    onCut={(e) => e.preventDefault()}
                    placeholder="Enter Password"
                  />
                  <span
                    className={`ti toggle-password ${
                      isPasswordVisible ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={togglePasswordVisibility}
                  ></span>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSubmitPassword}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BackUpRestore;
